import { db, auth, storage } from '@/plugins/firebase'
import firebase from 'firebase';
import 'firebase/app';
import { bus } from '@/main'

var lastVisible = ""

export async function getAssets({ commit }) {
    var assets = []
    commit("updateAssets", assets)

    await db.collection('assets').where("state", "!=", "deleted").orderBy("state").orderBy("createdAt", "desc").limit(12).get().then(async function (docs) {
        if (docs.empty) {
            return
        }

        lastVisible = docs.docs[docs.docs.length - 1]
        console.log("last", lastVisible);

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            assets.push(doc.data());
        }

        commit('updateAssets', assets)
    })
}

export async function getMoreAssets({ commit }) {
    var assets = []
    // commit("appendAssets", assets)
    console.log("getting more Assets from ", lastVisible)

    await db.collection('assets').where("state", "!=", "deleted").orderBy("state").orderBy("createdAt", "desc").startAfter(lastVisible).limit(12).get().then(async function (docs) {
        if (docs.empty) {
            return
        }

        lastVisible = docs.docs[docs.docs.length - 1]
        console.log("last", lastVisible);

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            assets.push(doc.data());
        }

        console.log(assets)

        commit('appendAssets', assets)
    })
}

export async function getAssetsByEntityId({ commit }, entityId) {
    var assets = []
    commit("updateAssets", assets)

    await db.collection('assets').where("state", "!=", "deleted").where("entity.id", "==", entityId).orderBy("state").orderBy("createdAt", "desc").limit(12).get().then(async function (docs) {
        if (docs.empty) {
            return
        }

        lastVisible = docs.docs[docs.docs.length - 1]
        console.log("last", lastVisible);

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            assets.push(doc.data());
        }

        commit('updateAssets', assets)
    })
}


export async function getMoreAssetsByEntityId({ commit }, entityId) {
    var assets = []
    // commit("appendAssets", assets)
    console.log("getting more Assets from ", lastVisible)

    await db.collection('assets').where("state", "!=", "deleted").where("entity.id", "==", entityId).orderBy("state").orderBy("createdAt", "desc").startAfter(lastVisible).limit(12).get().then(async function (docs) {
        if (docs.empty) {
            return
        }
        
        lastVisible = docs.docs[docs.docs.length - 1]

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            assets.push(doc.data());
        }

        console.log(assets)

        commit('appendAssets', assets)
    })
}



export async function createNewAsset({ commit }, { details }) {
    return new Promise((resolve, reject) => {
        const assetRef = db.collection('assets').doc()

        const asset = {
            id: assetRef.id,
            ...details,
            state: "active",
            createdBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        assetRef.set(asset).then(() => {
            console.log("Created new Asset")
            bus.$emit("show-snackbar", { text: "New Asset Created!", color: "success" });
            resolve()
        }).catch((err) => {
            bus.$emit("show-snackbar", { text: err, color: "error" });
            reject()
        })
    })

}

export async function updateAsset({ commit }, { details }) {
    return new Promise((resolve, reject) => {
        console.log("updating asset: ", details)
        const refObj = {
            ...details,
            state: "updated",
            updatedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        db.collection('assets').doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: "Asset updated!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })
    })
}

export async function deleteAsset({ commit }, { details }) {
    console.log("Asset To Delete: ", details)
    return new Promise((resolve, reject) => {
        const refObj = {
            ...details,
            state: "deleted",
            deletedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        db.collection('assets').doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: "Asset deleted!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })

        // db.collection('pins').doc(pinDetails.id).delete().then(function () {
        //     bus.$emit("show-snackbar", { text: "Pin Successfully Deleted!", color: "success" });
        //     resolve()
        // }).catch(function (error) {
        //     bus.$emit("show-snackbar", { text: error, color: "error" });
        //     reject()
        // });
    })
}


export async function searchAssets({ commit }, { searchTerm, entity }) {
    var dataArr = []
    commit("updateAssets", dataArr)

    if (entity) {
        await db.collection("assets").where("state", "!=", "deleted").where("searchTerms", "array-contains", searchTerm).where("entity.id", "==", entity.id).limit(12).get().then(async function (docs) {
            if (docs.empty) {
                return
            }
    
            lastVisible = docs.docs[docs.docs.length - 1]
            console.log("last", lastVisible);
    
            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }
    
            commit("updateAssets", dataArr)
        })
    } else {
        await db.collection("assets").where("state", "!=", "deleted").where("searchTerms", "array-contains", searchTerm).limit(12).get().then(async function (docs) {
            if (docs.empty) {
                return
            }
    
            lastVisible = docs.docs[docs.docs.length - 1]
            console.log("last", lastVisible);
    
            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }
    
            commit("updateAssets", dataArr)
        })
    }

   
}


export async function searchMoreAssets({ commit }, { searchTerm, entity }) {
    var dataArr = []
    //commit("updateAssets", dataArr)

    if (entity) {
        await db.collection("assets").where("state", "!=", "deleted").where("searchTerms", "array-contains", searchTerm).where("entity.id", "==", entity.id).startAfter(lastVisible).limit(12).get().then(async function (docs) {
            if (docs.empty) {
                return
            }
    
            lastVisible = docs.docs[docs.docs.length - 1]
    
            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }
    
            commit('appendAssets', dataArr)
        })

    } else {
        await db.collection("assets").where("state", "!=", "deleted").where("searchTerms", "array-contains", searchTerm).startAfter(lastVisible).limit(12).get().then(async function (docs) {
            if (docs.empty) {
                return
            }
    
            lastVisible = docs.docs[docs.docs.length - 1]
    
            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }
    
            commit('appendAssets', dataArr)
        })
    }

    
}

export async function uploadImage({ commit }, { image, index }) {
    commit("updateUploadProgress", { index: index, value: 0 })
    return new Promise((resolve, reject) => {
        function randomStr(len, arr) {
            var ans = "";
            for (var i = len; i > 0; i--) {
                ans += arr[Math.floor(Math.random() * arr.length)];
            }
            return ans;
        }

        console.log(image)
        const fileName = randomStr(20, '123456789abcdefghijklmnopqrstuvqxyz')

        const ref = storage.ref(fileName).put(image)


        ref.on(
            `state_changed`,
            (snapshot) => {
                commit("updateUploadProgress", { index: index, value: (snapshot.bytesTransferred / snapshot.totalBytes) * 100 })
            },
            (error) => {
                console.log(error.message);
                reject(error.message)
            },
            () => {


                ref.snapshot.ref.getDownloadURL().then((downloadUrl) => {
                    resolve({ firebaseUrl: downloadUrl, fileName })
                    commit("updateUploadProgress", { index: index, value: 0 })
                });

            }

        )

    })
}

